/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Container from "@/src/components/Container/Container";
import { ourServiceStyle } from "@/src/components/Sections/Generic/OurService/ourServiceStyle";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import { ourServiceContent } from "@/src/components/Sections/Generic/OurService/ourServiceContent";
import { useState } from "react";
import OurServiceTabContent from "@/src/components/Sections/Generic/OurService/OurServiceTabContent";
import Section from "@/src/components/Section/Section";

export default function OurService() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const getItemTitle = (id: string, title: string) => {
    return `${id}. ${title}`;
  };

  return (
    <Section sx={ourServiceStyle.ourService}>
      <Container variant={"lg"} showVerticalPadding={false}>
        <Stack spacing={{ xs: 6, md: 10 }}>
          <Box sx={{ textAlign: "center" }}>
            <ChipLegalbird sx={{ marginBottom: "1.5rem" }} label={"Unser Service"} light />
            <Typography component={"h2"} variant={"h3"}>
              Der beste und einfachste Weg, zu Ihrem Recht zu gelangen: Schnell, persönlich, transparent.
            </Typography>
          </Box>
          <Tabs
            slotProps={{
              list: {
                sx: ourServiceStyle.tabsList,
              },
              indicator: {
                sx: ourServiceStyle.tabsIndicator,
              },
            }}
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
          >
            {ourServiceContent.map((item, idx) => {
              return (
                <Tab
                  key={item.title}
                  label={item.id}
                  sx={ourServiceStyle.tab}
                  aria-controls={`our-service-tabpanel-${idx}`}
                  aria-label={`${getItemTitle(item.id, item.title)}`}
                  id={`our-service-tab-${idx}`}
                />
              );
            })}
          </Tabs>
          {ourServiceContent.map((item, idx) => (
            <OurServiceTabContent
              key={item.id}
              title={getItemTitle(item.id, item.title)}
              description={item.description}
              image={item.image}
              sx={{ display: activeTab === idx ? "flex" : "none" }}
              id={`our-service-tabpanel-${idx}`}
              aria-labelledby={`our-service-tab-${idx}`}
            />
          ))}
        </Stack>
      </Container>
    </Section>
  );
}
